import React from 'react';
import { useParams } from 'react-router';
import { Box, CircularProgress } from '@material-ui/core';
import { PublicAppBar } from '../../global/public-shell/public-app-bar/PublicAppBar';
import { TrialExpiredScreen } from './TrialExpiredScreen';
import { SubscriptionOptions } from './prices/SubscriptionOptions';
import { useSession } from '../../global/auth/useSession';
import { CampfireApolloProvider } from '../../global/config/ApolloContext';
import { SubscribedSuccessScreen } from './SubscribedSuccessScreen';

export function SubscriptionScreen() {
  const { screen } = useParams<{ screen: string }>();
  const { user, isLoading, isLoadingFromStorage } = useSession();

  if (isLoading || isLoadingFromStorage) {
    return (
      <Box
        style={{
          width: '100vw',
          height: '100vh',
          alignItems: 'center',
          marginLeft: 'auto',
          marginRight: 'auto',
          justifyItems: 'center',
          justifyContent: 'center',
          alignContent: 'center',
          display: 'flex',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <CampfireApolloProvider token={user?.token}>
      <Box width='100vw' height='100vh' display='flex' flexDirection='column' alignItems='stretch'>
        <PublicAppBar />
        <Box height='57px' />
        <Box flex={1} minHeight={0} display='flex' alignItems='center' justifyContent='center'>
          {(() => {
            switch (screen) {
              case 'trial-expired':
                return <TrialExpiredScreen />;
              case 'options':
                return <SubscriptionOptions />;
              case 'success':
                return <SubscribedSuccessScreen />;
              default:
                return null;
            }
          })()}
        </Box>
      </Box>
    </CampfireApolloProvider>
  );
}
